export default __webpack_public_path__ + "static/media/category_6.a17f6cd0.png";